import script from "./ProjectIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&setup=true&lang=js"

import "./ProjectIndex.vue?vue&type=style&index=0&id=72b4de16&lang=css"
import "./ProjectIndex.vue?vue&type=style&index=1&id=72b4de16&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b4de16"]])

export default __exports__